export enum QualityAssurancePermissionsEnum {
  ViewProjects = 'QA.PROJECT.VIEW',
  CreateClaimReviews = 'QA.REVIEWS.CLAIMS.CREATE',
  ViewClaimReviews = 'QA.REVIEWS.CLAIMS.VIEW',
  ViewFindings = 'QA.FINDING.VIEW',
  CreateFindings = 'QA.FINDING.CREATE',
  ReviewFindings = 'QA.FINDING.REVIEW',
  ViewComments = 'QA.COMMENT.VIEW',
  CreateComments = 'QA.COMMENT.CREATE',
  ReviewFindingEscalation = 'QA.FINDING.REVIEW_ESCALATION',
  CreateProjects = 'QA.PROJECT.CREATE',
  CreateRoundTable = 'QA.PROJECT.ROUND_TABLE.CREATE',
  ViewRoundTable = 'QA.PROJECT.ROUND_TABLE.VIEW',
  UpdateReviews = 'QA.REVIEWS.UPDATE',
}
